import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import { UtilService } from 'src/app/service/util';
import { CaracteristicaItem, CaracteristicaList } from '../interface/processo-pre-cadastro-produto-pdm';

@Injectable({
  providedIn: 'root'
})
export class PdmService {
  url = `${environment.urlApiProtheus}/wsrpdm`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) { }

  getCaracteristicas(CB1XPDM: string): Observable<CaracteristicaList> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<CaracteristicaList>(`${this.url}/caracteristicas/${CB1XPDM}`, httpOptions);
  }

  getCaracteristicaItem(CZC4COD: string): Observable<CaracteristicaItem> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<CaracteristicaItem>(`${this.url}/zc4/${CZC4COD}`, httpOptions);
  }
}
